const PagesHeader = ({ title }) => {
  return (
    <div className="pages-header-offset ml-10 xl:m-0">
      <h1 className="xl:text-3xl text-xl font-bold">{title}</h1>
    </div>
  );
};

export default PagesHeader;
